module.exports = __webpack_public_path__ + "static/media/mediaProduction.0a160503.jpg";